// src/pages/IntergenerationalMatching.jsx
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import IntergenerationalMatchingTinder from "@/components/matching-intergenerationnel/IntergenerationalMatchingTinder";

export default function IntergenerationalMatchingPage() {
  const { t } = useTranslation();

  const dummyHeirs = useMemo(() => [
    {
      id: "Sarah",
      name: "Sarah",
      age: 23,
      score: 92,
      preferences: [t("intergenerationalMatchingPage.heirs.sarah.preferences.landArt"), t("intergenerationalMatchingPage.heirs.sarah.preferences.sustainableArt")],
      values: [t("intergenerationalMatchingPage.heirs.sarah.values.sustainability"), t("intergenerationalMatchingPage.heirs.sarah.values.transmission")],
      imageUrl: "https://via.placeholder.com/300x200?text=Sarah",
    },
    {
      id: "James",
      name: "James",
      age: 35,
      score: 68,
      preferences: [t("intergenerationalMatchingPage.heirs.james.preferences.classical"), t("intergenerationalMatchingPage.heirs.james.preferences.renaissance")],
      values: [t("intergenerationalMatchingPage.heirs.james.values.investment")],
      imageUrl: "https://via.placeholder.com/300x200?text=James",
    },
  ], [t]);

  const dummyArtworks = useMemo(() => [
    {
      id: "art1",
      title: t("intergenerationalMatchingPage.artworks.suspendedForests.title"),
      year: 2021,
      medium: t("intergenerationalMatchingPage.artworks.suspendedForests.medium"),
      imageUrl: "https://via.placeholder.com/300x200?text=Artwork+1",
    },
    {
      id: "art2",
      title: t("intergenerationalMatchingPage.artworks.emeraldCascade.title"),
      year: 2019,
      medium: t("intergenerationalMatchingPage.artworks.emeraldCascade.medium"),
      imageUrl: "https://via.placeholder.com/300x200?text=Artwork+2",
    },
  ], [t]);

  const handleMatch = (art, heir) => {
    window.alert(t("intergenerationalMatchingPage.matchAlert", { artwork: art.title, heir: heir.name }));
  };

  const handleReject = (art, heir) => {
    console.log(t("intergenerationalMatchingPage.rejectLog", { artwork: art.title, heir: heir.name }));
  };

  return (
    <div className="max-w-2xl mx-auto mt-12">
      <h1 className="text-2xl font-semibold mb-6 text-center">
        {t("intergenerationalMatchingPage.title")}
      </h1>
      <IntergenerationalMatchingTinder
        artworks={dummyArtworks}
        heirs={dummyHeirs}
        onMatch={handleMatch}
        onReject={handleReject}
      />
    </div>
  );
}
